import { useRef } from 'react'

export default function usePropsRef<PropsType>(props: PropsType) {
  const storageRef = useRef<PropsType>()

  storageRef.current = Object.assign(storageRef.current || {}, props)

  return storageRef
}
